import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { getMessages, hasMessages, getType } from 'selectors/shared/flashMessage'
import { Actions as FlashAction } from 'actions/shared/flashMessage'
import { FlashMessage, FlashMessages, FlashMessageType } from 'types/Shared/FlashMessage'

const mapStateToProps = createStructuredSelector({
  available: hasMessages,
  messages: getMessages,
  type: getType,
})

const mapDispatchToProps = (dispatch: (...args: Array<any>) => any) => ({
  addMessage: (payload: FlashMessage) => dispatch(FlashAction.ADD(payload)),
  clearMessage: () => dispatch(FlashAction.CLEAR()),
})

export type ConnectorProps = {
  addMessage: (payload: FlashMessage) => void
  available: boolean
  clearMessage: () => void
  messages: FlashMessages
  type: FlashMessageType
}

export default connect(mapStateToProps, mapDispatchToProps)
